import { Search, X } from 'lucide-react';
import { CommandBarAiCard, CommandBarResultItem } from './CommandBarParts';
import { getIntentLabel } from './commandRegistry';

/** Top search-input row of the ⌘K palette. */
export function CommandBarSearchInput({ query, setQuery, onKeyDown, onClose, inputRef }) {
  return (
    <div className="flex items-center gap-3 px-5 py-4" style={{ borderBottom: '1px solid var(--pd-border)' }}>
      <Search className="w-5 h-5 flex-shrink-0" style={{ color: 'var(--pd-subtle)' }} />
      <input
        ref={inputRef}
        data-testid="commandbar-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Ask PolkDesQ... e.g. 'Call Ravi at 3 PM'"
        className="flex-1 text-sm outline-none bg-transparent"
        style={{ color: 'var(--pd-text)' }}
      />
      <button
        data-testid="commandbar-close-button"
        onClick={onClose}
        className="pd-icon-button"
        style={{ width: 38, height: 38 }}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

/** Left results column: AI loading state, AI card, nav results, empty state. */
export function CommandBarResults({ aiLoading, aiResult, results, selectedIndex, query, onExecuteAi, onClose }) {
  return (
    <div
      className="max-h-[520px] overflow-y-auto py-2 border-r custom-scrollbar"
      style={{ borderColor: 'var(--pd-border)' }}
    >
      {aiLoading && (
        <div className="px-5 py-4 flex items-center gap-3">
          <div
            className="w-5 h-5 rounded-full animate-spin"
            style={{ border: '2px solid var(--pd-border)', borderTopColor: 'var(--pd-focus)' }}
          />
          <span className="text-sm" style={{ color: 'var(--pd-muted)' }}>Understanding command...</span>
        </div>
      )}

      {aiResult && (
        <CommandBarAiCard
          aiResult={aiResult}
          isSelected={selectedIndex === 0}
          getIntentLabel={getIntentLabel}
          query={query}
          onExecute={onExecuteAi}
        />
      )}

      {results.map((result, idx) => (
        <CommandBarResultItem
          key={`${result.group}-${result.title}`}
          result={{ ...result, index: idx }}
          isSelected={selectedIndex === (aiResult ? idx + 1 : idx)}
          onSelect={() => { if (result.action) result.action(); onClose(); }}
        />
      ))}

      {results.length === 0 && !aiResult && !aiLoading && query && (
        <div className="px-5 py-8 text-center">
          <p className="text-sm" style={{ color: 'var(--pd-muted)' }}>No results for "{query}"</p>
          <p className="text-xs mt-1" style={{ color: 'var(--pd-subtle)' }}>
            Try a different search or a clearer command.
          </p>
        </div>
      )}
    </div>
  );
}
